import { mapValues } from 'lodash';

/**
 * Adds a "px" suffix to all object keys, to be used later in the "style" attribute.
 * @param  {Object} obj The object to map.
 * @return {Object}     A new object, containing only relevant keys.
 */
const addPixels = (obj) => mapValues(obj, (value) => `${value}px`);

export default addPixels;
